import './Input.less'
import Input from './Input'
export type { InputRef, InputProps } from './iInput'
export default Input
